// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/droplets.js';

import { paths } from '../generated/droplets';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('droplets', Original, paths);
